import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import QueryClientProvider from './providers/QueryClientProvider'

import { ENVIRONMENT, NODE_ENV } from './lib/env'
import CacheProvider from './providers/CacheProvider'

import './i18n'
import VDRErrorBoundary from './providers/ErrorBoundary'

if (NODE_ENV === 'production') {
  Sentry.init({
    environment: ENVIRONMENT,
    dsn: 'https://631db56000c04f64ab94184f890be642@o372003.ingest.sentry.io/5537398',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  })
}

const container = document.getElementById('root')
if (container) {
  const root = createRoot(container)

  root.render(
    <React.StrictMode>
      <VDRErrorBoundary>
        <CacheProvider>
          <QueryClientProvider>
            <App />
          </QueryClientProvider>
        </CacheProvider>
      </VDRErrorBoundary>
    </React.StrictMode>
  )
} else {
  console.error('Root container not found')
}
